import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Box } from '../box';
import { usePaletteColor } from '../theme';
import { makeEnum, withVersion } from '../utils';
export const ColorIndicatorSize = makeEnum(10, 18, 24);
const COLOR_INDICATOR_FILL = 'components.avatar.fill';
const ColorIndicatorImpl = React.forwardRef((props, ref) => {
    const { color, size = 18, className, 'data-role': dataRole = 'color-indicator', 'data-role-value': dataRoleValue } = props;
    const fallbackColor = usePaletteColor(COLOR_INDICATOR_FILL);
    const resolvedColor = color || fallbackColor;
    return (_jsx(Box, { ref: ref, className: className, "data-role": dataRole, "data-role-value": dataRoleValue, borderColor: "divider", sx: {
            width: size,
            height: size,
            minWidth: size,
            borderRadius: '50%',
            backgroundColor: resolvedColor,
            border: '1px solid'
        } }));
});
ColorIndicatorImpl.displayName =
    'ColorIndicator';
export const ColorIndicator = withVersion(ColorIndicatorImpl, '1.0.0');
